import React from 'react';
import { ScaledViewport } from '../ScaledViewport';

/** The live, published REKOVELLE teaser Snak. */
export const LIVE_SNAK_URL = 'https://rekovelle.snakker.io/';
interface PhoneSnakProps {
  /** Sizing classes — set a height; width follows the phone aspect ratio. */
  className: string;
  label?: string;
}

/** The live REKOVELLE Snak (rekovelle.snakker.io) inside a phone frame. */
export function PhoneSnak({
  className,
  label = 'Live REKOVELLE teaser Snak'
}: PhoneSnakProps) {
  return <ScaledViewport baseWidth={390} baseHeight={760} bezel={10} radius={0.13} className={className} style={{
    aspectRatio: '410 / 780'
  }} deviceClassName="bg-ink shadow-[0_40px_80px_-30px_rgba(14,27,51,0.5)]" data-id="element-272" data-mp="29u05ap55p730">
      <iframe src={LIVE_SNAK_URL} title={label} width={390} height={760} className="block h-[760px] w-[390px] border-0 bg-white" allow="autoplay; fullscreen" data-id="element-273" data-mp="2jmea5qrj6tte" />
    </ScaledViewport>;
}